
    import * as React from 'react';

    const MailOpened14 = ({ color = 'currentcolor', height = '14px', width = '14px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 14 14" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M11.935 7.38477H12V14.0002H2V7.38477H2.06494L6.99999 11.7694L11.935 7.38477ZM1 6.38477H2H12H13V7.38477V14.0002V15.0002H12H2H1V14.0002V7.38477V6.38477Z" /><path d="M7.00003 1.53891L12.7273 6.38507V6.6543L1.27277 6.6543V6.38507L7.00003 1.53891Z" stroke="#979899" /></svg>
        </div>
      );
    };

    MailOpened14.displayName = 'MailOpened14';

    export default MailOpened14;
  